/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export const useStoredClientPersonalData = () => {
  return useQuery({
    queryKey: queryKeys.client.personalDataStored,
    staleTime: Infinity,
    initialData: null,
  });
};
